/* tslint:disable */
/* eslint-disable */
/**
 * Linqx API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  JoinWaitlistDto,
  WaitlistResponse,
} from '../models/index';
import {
    JoinWaitlistDtoFromJSON,
    JoinWaitlistDtoToJSON,
    WaitlistResponseFromJSON,
    WaitlistResponseToJSON,
} from '../models/index';

export interface WaitlistControllerJoinWaitlistRequest {
    joinWaitlistDto: JoinWaitlistDto;
}

/**
 * 
 */
export class WaitlistApi extends runtime.BaseAPI {

    /**
     * Get the current number of people on the waitlist
     * Get waitlist stats
     */
    async waitlistControllerGetStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/waitlist/stats`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get the current number of people on the waitlist
     * Get waitlist stats
     */
    async waitlistControllerGetStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.waitlistControllerGetStatsRaw(initOverrides);
    }

    /**
     * Add an email to the Linqx waitlist. No authentication required.
     * Join the waitlist
     */
    async waitlistControllerJoinWaitlistRaw(requestParameters: WaitlistControllerJoinWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WaitlistResponse>> {
        if (requestParameters['joinWaitlistDto'] == null) {
            throw new runtime.RequiredError(
                'joinWaitlistDto',
                'Required parameter "joinWaitlistDto" was null or undefined when calling waitlistControllerJoinWaitlist().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/waitlist/join`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JoinWaitlistDtoToJSON(requestParameters['joinWaitlistDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WaitlistResponseFromJSON(jsonValue));
    }

    /**
     * Add an email to the Linqx waitlist. No authentication required.
     * Join the waitlist
     */
    async waitlistControllerJoinWaitlist(requestParameters: WaitlistControllerJoinWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WaitlistResponse> {
        const response = await this.waitlistControllerJoinWaitlistRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
